import { spansOfAxis, weightInSpan } from './boxSpan.js';
export default function fillPlaneByAverage(frames, [sourceWidth, sourceHeight], [width, height], [factorI, factorJ], values, frameWeights) {
    if (!frames.length) {
        for (let index = 0; index < width * height; index++) {
            values[index] = 0;
        }
        return;
    }
    const columns = spansOfAxis(sourceWidth, width, factorI);
    const rows = spansOfAxis(sourceHeight, height, factorJ);
    const round = !(values instanceof Float32Array || values instanceof Float64Array);
    const columnSums = new Float64Array(sourceWidth);
    for (let j = 0; j < height; j++) {
        const rowSpan = rows[j];
        let rowWeight = 0;
        columnSums.fill(0);
        for (let f = 0; f < frames.length; f++) {
            const frame = frames[f];
            const frameWeight = frameWeights?.[f] ?? 1;
            for (let row = rowSpan.first; row < rowSpan.end; row++) {
                const weight = frameWeight * weightInSpan(rowSpan, row);
                const start = row * sourceWidth;
                rowWeight += weight;
                for (let i = 0; i < sourceWidth; i++) {
                    columnSums[i] += weight * frame[start + i];
                }
            }
        }
        const targetRow = j * width;
        for (let i = 0; i < width; i++) {
            const span = columns[i];
            let sum = 0;
            let columnWeight = 0;
            for (let column = span.first; column < span.end; column++) {
                const weight = weightInSpan(span, column);
                sum += weight * columnSums[column];
                columnWeight += weight;
            }
            const count = columnWeight * rowWeight;
            const value = count ? sum / count : 0;
            values[targetRow + i] = round ? Math.round(value) : value;
        }
    }
}
